module.exports = __webpack_public_path__ + "img/img_3.4cf73594.jpg";